import { BulkActionsComponent } from 'commons/components';
import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { useTranslation } from 'core/i18n/i18n';
import { useOperatorCustomNotificationsNavigation } from 'modules/settings/pods/settings-operator-custom-notifications/hooks/use-operator-custom-notifications-navigation.hook';
import { OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX } from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.constants';
import {
    OperatorCustomNotificationAction,
    OperatorCustomNotificationRow,
} from 'modules/settings/pods/settings-operator-custom-notifications/settings-operator-custom-notifications.model';

export interface OperatorCustomNotificationsBulkActionsContainerProps {
    selectedRows: OperatorCustomNotificationRow[];
    areAllActive: boolean;
    areAllInactive: boolean;
    onClearSelection: VoidFunction;
    onRequestAction: (action: OperatorCustomNotificationAction, notifications: OperatorCustomNotificationRow[]) => void;
}

export const OperatorCustomNotificationsBulkActionsContainer: React.FC<
    OperatorCustomNotificationsBulkActionsContainerProps
> = ({ selectedRows, areAllActive, areAllInactive, onClearSelection, onRequestAction }) => {
    const { t } = useTranslation();
    const { navigateToEdit } = useOperatorCustomNotificationsNavigation();

    if (selectedRows.length === 0) {
        return null;
    }

    const isSingleSelection = selectedRows.length === 1;

    return (
        <BulkActionsComponent
            options={[
                <PocTypography key="operator-custom-notifications-selected" element="span" variant="subtitle1">
                    {t(`${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.selected`, {
                        amount: selectedRows.length,
                    })}
                </PocTypography>,
                <PocButton
                    key="operator-custom-notifications-clear-all"
                    variant="tertiary"
                    size="medium"
                    onClick={onClearSelection}
                >
                    {t(`${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.clear-all`)}
                </PocButton>,
            ]}
        >
            {isSingleSelection && (
                <BulkActionButtonComponent
                    text={t(`${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.actions.edit`)}
                    iconName="write"
                    onClick={() => navigateToEdit(selectedRows[0].id)}
                />
            )}
            {areAllInactive && (
                <BulkActionButtonComponent
                    text={t(`${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.actions.activate`)}
                    iconName="circle_on_off"
                    onClick={() => onRequestAction('activate', selectedRows)}
                />
            )}
            {areAllActive && (
                <BulkActionButtonComponent
                    text={t(`${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.actions.deactivate`)}
                    iconName="circle_remove"
                    onClick={() => onRequestAction('deactivate', selectedRows)}
                />
            )}
            <BulkActionButtonComponent
                text={t(`${OPERATOR_CUSTOM_NOTIFICATIONS_BULK_ACTIONS_I18N_PREFIX}.actions.delete`)}
                iconName="delete"
                onClick={() => onRequestAction('delete', selectedRows)}
            />
        </BulkActionsComponent>
    );
};
